import clsx from 'clsx'
import type { Page_Flexcontent_Flex_Misc } from '~/graphql/types'

export default function WhiteSpace({ fields }: { fields: Page_Flexcontent_Flex_Misc }) {
  return <section className={clsx('h-[50px] lg:h-[100px]', fields.dark ? `bg-lm-shoe` : `bg-lm-machine`)} id="WhiteSpace" />
}
